import React, { useState } from "react";
import PropTypes from "prop-types";
import CourseInfoModal from "../courseinfo/CourseInfo";
import { FaCircleChevronDown, FaCircleChevronUp } from "react-icons/fa6";
import "./card.css";


function Card({ title, imageSource, level, program, price, courseId, description }) {
  const [isModal, setModal] = useState(false);


  const AccordionItem = ({ title, description }) => {
    const [isItemActive, setIsItemActive] = useState(false);
    const toggleAccordion = () => setIsItemActive(!isItemActive);

    return (
      <>
        <div className="accordion" onClick={toggleAccordion}>
          {title}
          <span className="accordion-item-title">
            {isItemActive ? <FaCircleChevronUp /> : <FaCircleChevronDown />}
          </span>
        </div>
        <div
          style={{
            maxHeight: isItemActive ? "150px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease",
          }}
        >
          <p>{description}</p>
        </div>
      </>
    );
  };

  const accordion_content = [
    { title: title, description: description },
    { title: "Programa", description: program },
    { title: "Inversión", description: price ? `$${price} dolares` : "Consultar precio" },
    { title: "Formas de pago", description: "Opciones de pago disponibles..." },
  ];

  return (
    <>
      <div className="card text-center">
        <div className="overflow">
          <img src={imageSource} alt={title} className="card-img-top" />
        </div>
        <div className="card-body">
          <h4 className="card-title">{title}</h4>
          <p className="card-text text-secundary">{level}</p>
          <p className="card-text text-secundary">{program}</p>
          <button className="btn-size" onClick={() => setModal(true)}>Ampliar información</button>
        </div>
      </div>
      {isModal &&
        (<CourseInfoModal
          isVisible={isModal}
          title="Información del curso"
          content={accordion_content.map((item, i) => (
            <AccordionItem key={i + item.title} title={item.title} description={item.description} />
          ))}
          footer={{
            title,
            price,
            courseId
          }}
          onClose={() => setModal(false)}
        />
        )}
    </>
  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  imageSource: PropTypes.string,
  price: PropTypes.number,
  courseId: PropTypes.string,
};

export default Card;
